// 车辆支持页
import { httpRequest } from '../request';

// 获取产品子类和产品系列数据
export function getProductAndSeries(data: any) {
  return httpRequest({
    url: 'product/category/tree/two-three',
    data
  });
}

// 获取首页热门服务更多服务配置显示数据
export function getIndexConfigList() {
  return httpRequest({
    url: 'product/sales-category-config/service/list'
  });
}

// 获取产品子系列/型号数据
export function getSubSeriesOrModel(data: any) {
  return httpRequest({
    url: 'product/common/list',
    data
  });
}

// 车辆服务页首页,获取是否显示自助维修
export function getSelfRepairFlag(data: any) {
  return httpRequest({
    url: 'device-content/index',
    data
  });
}

// 获取视频分类新增
export function getVideoCategory(data: any) {
  return httpRequest({
    url: 'teaching-video/category/list/v2',
    data
  });
}

// 获取视频列表new
export function getVideoList(data: any) {
  return httpRequest({
    url: 'teaching-video/video/list/v2',
    data,
    method: 'post'
  });
}

// 问题反馈
export function feedBack(data: any) {
  return httpRequest({
    url: 'self-service/feedback/save',
    method: 'post',
    data
  });
}
export function getProductDetail(data: any) {
  return httpRequest({
    url: 'common/category/detail',
    method: 'post',
    data
  });
}

// 车辆支持页-邮箱
export function getEmailList() {
  return httpRequest({
    url: 'common/email/list'
  });
}

// 车辆支持页-法规
export function getLawList() {
  return httpRequest({
    url: 'common/law/list'
  });
}
// 广告位
export function getAdActivities(data: any) {
  return httpRequest({
    data,
    method: 'post',
    url: 'common/ad/list'
  });
}
